/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_BodyInputs */

const en_map_body = /** @type {(inputs: Map_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At the centre, one database and the domains that own it. Around it, the people who work in Nexxt, from Tomorrow's own teams to the systems of the world. Pick a journey and follow it.`)
};

/**
* | output |
* | --- |
* | "At the centre, one database and the domains that own it. Around it, the people who work in Nexxt, from Tomorrow's own teams to the systems of the world. Pick..." |
*
* @param {Map_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const map_body = /** @type {((inputs?: Map_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_map_body(inputs)
});